import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ErrorDetailTaskCheckResponse } from '@/types/apps/error-detail-task-check.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ErrorDetailTaskCheckGraphQLServiceInterface {}

type ErrorDetailTaskCheckListResponse =
    GqlListResponse<ErrorDetailTaskCheckResponse>;

export class ErrorDetailTaskCheckGraphQLService
    extends BaseService
    implements ErrorDetailTaskCheckGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'errorDetailTaskCheck';
    }

    public getFields(): Record<string, any> {
        return {
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            errorDetailId: true,
            errorDetailName: true,
            errorDetailTaskCheckStatus: true,
            errorTime: true,
            errorTypeId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            predictivedReason: true,
            proposals: true,
            repairTimeDouble: true,
            severityLevelId: true,
            taskCheckId: true,
            errorDetail: {
                code: true,
                createdDate: true,
                description: true,
                errorTypeId: true,
                id: true,
                name: true,
                severityLevelId: true,
                solution: true,
            },
            errorType: {
                name: true,
            },
            taskCheck: {
                assigneeName: true,
                assigneeId: true,
                device: {
                    name: true,
                    id: true,
                },
                ticket: {
                    customer: {
                        name: true,
                        id: true,
                    },
                },
            },
            severityLevel: {
                color: true,
                createdBy: true,
                createdDate: true,
                description: true,
                id: true,
                isDeleted: true,
                name: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ErrorDetailTaskCheckListResponse> {
        return this.fetchGqlList<ErrorDetailTaskCheckListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('errorDetailTaskCheck', {
            userId: this.getQueryById(),
        });
    }
}
